
import _ from 'lodash';

/* @ngInject */
export default function officeDetailController($state, OfficesFactory, $stateParams, UserData, $scope, $rootScope, HPRoles, ModalService) {
    const vm = this;

    vm.canViewACH = false;
    vm.showDeleteOfficeButton = false;

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.backToOffices = function () {
        $state.go('accounts', { accountsPage: 'offices', accountId: null });
    };


    vm.deleteOffice = function () {
        const modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/offices/deleteOffice/deleteOffice.html',
            windowClass: 'delete-office',
            controller: 'DeleteOfficeController',
            controllerAs: 'deleteOffice',
            size: 'full-screen',
            resolve: {
                selectedOffice() {
                    return vm.officeProfile;
                },
            },
        });

        modal.result.then((result) => {
            if (result === true) {
                // If user is successfully deleted, take the user to the users page
                $state.go('accounts', { accountsPage: 'offices', accountId: null });
            }
            ModalService.closeLgModal();
        });
    };


    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions            =
	 ======================================== */
    function init() {
        getOfficeProfile();

        $rootScope.$on('LocationNicknameUpdated', (event, payload) => {
            vm.officeProfile.LocationDetail.LocationNickname = payload.LocationNickname;
        });
    }

    function getOfficeProfile() {
        const data = {
            ContractorLocationId: Number($stateParams.accountId),
        };
        UserData.getUserData().then((response) => {
            const currentRole = _.find(HPRoles, (key, other) => other === response.Roles[0]);
            vm.canViewACH = currentRole.isAdmin;
            data.IncludeACHInfo = currentRole.isAdmin;
            OfficesFactory.getOfficeProfile(data).then((response) => {
                vm.officeProfile = response.data;
                // (ajt - 6/24/2016) Add check to ensure delete button is only displayed if number of offices > 1 or office is not Main Office
                // (ajt - 7/7/2016) Add additional check for UserRole Rank = 1 (Company level user)
                UserData.getKBYGLocations().then((response) => {
                    vm.showDeleteOfficeButton = !vm.officeProfile.LocationDetail.IsMaster && response.length > 1 && !!currentRole && currentRole.rank === 1;
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/accounts/offices/officeDetailController.js